import { render, staticRenderFns } from "./ques2.vue?vue&type=template&id=0bfb4940"
import script from "./ques2.vue?vue&type=script&lang=js"
export * from "./ques2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports